import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { TransferOffer } from "@/modules/transfer-market/entity";
import TransferOfferSlim from "@/modules/transfer-market/components/TransferOfferSlim.vue";
import NavBarMenu from "@/modules/transfer-market/pages/NavBarMenu.vue";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const query = ref(TransferOffer.createQueryBuilder('offer').innerJoinAndSelect('offer.player', 'player').innerJoinAndSelect('player.country', 'country').innerJoinAndSelect('offer.team', 'team').innerJoinAndSelect('team.country', 'teamCountry').innerJoinAndSelect('offer.playersTeam', 'playersTeam').where('playersTeam.user = true OR team.user = true').orderBy('offer.id', "DESC"));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: "",
        "no-content-padding": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('offers')), 1)]),
        submenu: _withCtx(({
          route
        }) => [_createVNode(NavBarMenu)]),
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          query: query.value,
          class: "mt-2"
        }, {
          default: _withCtx(({
            items
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, offer => {
            return _openBlock(), _createBlock(TransferOfferSlim, {
              key: offer.id,
              offer: offer,
              class: "mb-2"
            }, null, 8, ["offer"]);
          }), 128))]),
          _: 1
        }, 8, ["query"])]),
        _: 1
      });
    };
  }
});